document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('[data-tilt-hero-wrapper]');
  if (!wrappers.length) return;

  const mediaQuery = window.matchMedia('(min-width: 750px)');

  function heightRatioFor(wrapper) {
    const aspect = wrapper.dataset.tiltAspect || '4-5';
    /* 4:5 portrait (w:h) → h/w = 5/4; 5:4 landscape → h/w = 4/5 */
    if (aspect === '5-4') return 4 / 5;
    return 5 / 4;
  }

  function rotateAndScaleAll() {
    const width = window.innerWidth;
    const extraWidth = Math.max(0, width - 750);

    wrappers.forEach((wrapper) => {
      const image = wrapper.querySelector('.hero-image');
      if (!image || !mediaQuery.matches) return;

      const aspect = wrapper.dataset.tiltAspect || '4-5';
      /* 5:4: stronger tilt, opposite sign; 4:5: original curve */
      const maxDeg = aspect === '5-4' ? 56 : 45;
      const mult = aspect === '5-4' ? 0.11 : 0.05;
      let degMag = Math.min(maxDeg, extraWidth * mult);
      if (aspect === '5-4') {
        degMag = Math.max(degMag, 14);
      }
      const radians = (degMag * Math.PI) / 180;
      const rotationDeg = aspect === '5-4' ? -degMag : degMag;

      const iw = image.offsetWidth;
      const ih = iw * heightRatioFor(wrapper);

      const rotatedWidth =
        Math.abs(iw * Math.cos(radians)) + Math.abs(ih * Math.sin(radians));
      const rotatedHeight =
        Math.abs(iw * Math.sin(radians)) + Math.abs(ih * Math.cos(radians));

      const scale = Math.min(1, width / rotatedWidth);

      wrapper.style.height = `${rotatedHeight * scale}px`;
      image.style.transform = `translate(-50%, -50%) rotate(${rotationDeg}deg) scale(${scale})`;
    });
  }

  let resizeRaf = 0;
  function onResize() {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(rotateAndScaleAll);
  }

  function resetAll() {
    wrappers.forEach((wrapper) => {
      const image = wrapper.querySelector('.hero-image');
      if (!image) return;
      image.style.transform = '';
      wrapper.style.height = '';
      wrapper.style.transform = '';
      image.style.left = '';
      image.style.top = '';
    });
  }

  function handleTabletChange(e) {
    if (e.matches) {
      rotateAndScaleAll();
      window.addEventListener('resize', onResize);
    } else {
      window.removeEventListener('resize', onResize);
      resetAll();
    }
  }

  mediaQuery.addEventListener('change', handleTabletChange);
  handleTabletChange(mediaQuery);
});
